import { render, staticRenderFns } from "./GroupRent.vue?vue&type=template&id=58890624&"
import script from "./GroupRent.vue?vue&type=script&lang=js&"
export * from "./GroupRent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports